import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import arrayMove from 'array-move';

import InterestsBenchmarksList from './InterestsBenchmarksList';
import ArrayUtil from '../../../utils/ArrayUtil';

class InterestsBenchmarks extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: ['interest'],
    };

    this.onSortEnd = this.onSortEnd.bind(this);
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    const { benchmarks, onChange } = this.props;
    const { dimensionBenchmarks } = benchmarks;
    const newDimensionBenchmarks = arrayMove(dimensionBenchmarks, oldIndex, newIndex);

    const sortedPriority = newDimensionBenchmarks.map((benchmark, index) => (
      {
        code: benchmark.code,
        displayName: benchmark.displayName,
        description: benchmark.description,
        priority: index + 1,
      }
    ));
    onChange({
      dimensionBenchmarks: sortedPriority,
    });
  };

  render() {
    const {
      templates, benchmarks, isEdit, hintsCS, hintsJPS, hintsSJL,
    } = this.props;
    const { expanded } = this.state;
    // get concurrent study hints
    const csBenchmarks = hintsCS && ArrayUtil.isNotEmpty(hintsCS) ? hintsCS : [];

    // get job profile survey hints
    const jpsBenchmarks = hintsJPS && ArrayUtil.isNotEmpty(hintsJPS) ? hintsJPS : [];

    // get standard job hints
    const sjlBenchmarks = hintsSJL && ArrayUtil.isNotEmpty(hintsSJL.behaviorStandardJobBenchmarks)
      ? hintsSJL.interestsStandardJobBenchmarks
      : [];

    if (!benchmarks || !benchmarks.dimensionBenchmarks || ArrayUtil.isEmpty(benchmarks.dimensionBenchmarks)) {
      return null;
    }

    let { dimensionBenchmarks } = benchmarks;

    dimensionBenchmarks = dimensionBenchmarks.slice();
    dimensionBenchmarks = dimensionBenchmarks.map(d => ({
      dimensionRange: d,
      hintCSRange: csBenchmarks.filter(h => h.dimensionName === d.code)[0],
      hintJPSRange: jpsBenchmarks.filter(h => h.dimensionName === d.code)[0],
      hintSJLRange: sjlBenchmarks.filter(h => h.dimensionName === d.code)[0],
      template: templates.filter(t => t.name === d.code)[0],
    }));

    return (
      <div className="accordion-legacy-container">
        <Accordion preExpanded={expanded} allowZeroExpanded>
          <AccordionItem uuid="interest">
            <AccordionItemHeading>
              <AccordionItemButton>
                <span className="t-large">{benchmarks.displayName}</span>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className="accordion-panel ">
              <div className="abilityContainer">
                <InterestsBenchmarksList
                  dimensionBenchmarks={dimensionBenchmarks}
                  useDragHandle
                  isEdit={isEdit}
                  onSortEnd={this.onSortEnd}
                />
              </div>
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      </div>
    );
  }
}

InterestsBenchmarks.propTypes = {
  benchmarks: PropTypes.objectOf(PropTypes.any),
  hintsCS: PropTypes.objectOf(PropTypes.any),
  hintsJPS: PropTypes.objectOf(PropTypes.any),
  hintsSJL: PropTypes.objectOf(PropTypes.any),
  templates: PropTypes.arrayOf(PropTypes.any).isRequired,
  isEdit: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

InterestsBenchmarks.defaultProps = {
  benchmarks: null,
  hintsCS: {},
  hintsJPS: {},
  hintsSJL: {},
};

export default connect()(InterestsBenchmarks);
